import SeoHead from "@/components/feature/SeoHead";
import { mangaWorks } from "@/mocks/manga";
import { homeFaqs } from "./components/FaqSection";
import Hero from "./components/Hero";
import LatestUpdates from "./components/LatestUpdates";
import HotSection from "./components/HotSection";
import CategoryNav from "./components/CategoryNav";
import RankingSection from "./components/RankingSection";
import Features from "./components/Features";
import FaqSection from "./components/FaqSection";
import CtaBand from "./components/CtaBand";

export default function Home() {
  const hotList = [...mangaWorks].sort((a, b) => a.hot - b.hot).slice(0, 6);

  const jsonLd = [
    {
      "@type": "WebPage",
      "@id": "https://workoutpro0.github.io/#webpage",
      "url": "https://workoutpro0.github.io/",
      "name": "《健身教练》漫画-免费阅读漫画全集-43423漫画网",
      "isPartOf": { "@id": "https://workoutpro0.github.io/#website" },
      "inLanguage": "zh-CN",
    },
    {
      "@type": "ItemList",
      "name": "热门推荐漫画",
      "itemListElement": hotList.map((work, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: `${work.title}漫画`,
        url: `https://workoutpro0.github.io/manga/${work.id}`,
      })),
    },
    {
      "@type": "FAQPage",
      "mainEntity": homeFaqs.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: { "@type": "Answer", text: item.a },
      })),
    },
  ];

  return (
    <>
      <SeoHead
        title="《健身教练》漫画-免费阅读漫画全集-43423漫画网"
        path="/"
        type="website"
        jsonLd={jsonLd}
      />
      <Hero />
      <LatestUpdates />
      <HotSection />
      <CategoryNav />
      <RankingSection />
      <Features />
      <FaqSection />
      <CtaBand />
    </>
  );
}